import { DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@app/app.service';
import { TableModule } from '@app/modules/table/table.module';
import { PanelTitleModule } from '@components/panel-title/panel-title.module';
import { FuiButtonComponent, FuiIconComponent, FuiSkeletonComponent } from '@fui/fui-components';
import { SocketsModule, SocketsService } from '@fui/fui-sockets';
import { TruncatePipe } from '@pipes/truncate/truncate.pipe';
import {
    HeaderComponent_AfterViewInit,
    IHeaderComponent_AfterViewInit,
} from 'src/shared/sockets/layout/header.interface';
import { HeaderButtonComponent } from './components/header-button/header-button.component';
import { ProfilerPageComponent } from './components/profiler-page/profiler-page.component';
import { ProfilerService } from './profiler.service';

@NgModule({
    declarations: [HeaderButtonComponent, ProfilerPageComponent],
    imports: [
        CommonModule,
        DialogModule,
        TruncatePipe,
        SocketsModule,
        FuiButtonComponent,
        FuiIconComponent,
        FuiSkeletonComponent,
        TableModule,
        PanelTitleModule,
    ],
    providers: [ProfilerService],
})
export class ProfilerModule {
    private readonly socketsService = inject(SocketsService);

    constructor() {
        // Добавляемся в очередь инициализации
        this.socketsService.addInitializer(() => this.init());
    }

    init() {
        const router = inject(Router);
        const appService = inject(AppService);

        // Добавляем свои роуты
        const routerConfig = router.config;
        routerConfig.unshift({
            path: 'profiler',
            component: ProfilerPageComponent,
        });
        router.resetConfig(routerConfig);

        // HeaderComponent_AfterViewInit
        this.socketsService.subscribe<IHeaderComponent_AfterViewInit>(
            'Profiler',
            HeaderComponent_AfterViewInit,
            async (data: IHeaderComponent_AfterViewInit) => {
                if (appService.accessMatrix?.profiler?.show === 1) {
                    data.vcrHeaderRight.createComponent(HeaderButtonComponent);
                }
            },
        );
    }
}
